import React, { Fragment } from 'react';

/**
 * Builds a JSX element for displaying tooltip messages.
 * Ensures messages are properly formatted with line breaks.
 * @param {string|string[]} messages - A single message string or an array of message strings.
 * @returns {React.Element|null} JSX element with messages separated by line breaks, or null if no valid messages.
 */
export const buildTooltipMessage = messages => {
  const messageArray = Array.isArray(messages) ? messages : [messages];
  const validMessages = messageArray.filter(msg => typeof msg === 'string');

  if (validMessages.length === 0) {
    return null; // Return null if no valid messages are provided
  }

  return (
    <>
      {validMessages.map((tooltipMessage, index) => (
        <Fragment key={index}>
          {tooltipMessage}
          {/* Add <br/> except for the last message */}
          {index < validMessages.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
};
